import dayjs from 'dayjs';
import { debounce, isInteger } from 'lodash';
import { shareData } from '../Config/widgetConfigMixin';
import { checkPermissionList, isEqualExclude } from '../util';
// import { mapGetters } from 'vuex';
// eslint-disable-next-line
const requestSprintList = ['CumulativeFlowDiagram', 'StatisticsWidget', 'ChartWidget', 'BurndownWidget', 'BurnupWidget'];
export default {
  props: {
    json: {
      type: String,
      required: true
    },
    widget: {
      type: Object,
      required: true
    },
    isPreview: {
      type: Boolean,
      default: false
    },
    isPreviewing: {
      type: Boolean,
      default: false
    },
    isPreviewMode: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isPreviewing(val){
      if (this.changeFlag && !val) {
        this.onSettingsChange(this.json);
      }
      this.changeFlag = 0;
    },
    json: {
      immediate: true,
      handler(n, o) {
        // n !== o
        if (!isEqualExclude(n, o, ['title'])) {
          if (isEqualExclude(n, o, ['showTitleSpring', ...(this.saveExcludes || [])])) {
            return this.onlySaveSetting(n);
          }
          this.changeFlag++;
          if (!this.isPreviewing) {
            this.onSettingsChange(n);
            if (o){
              this.isNeedSaveResult = true;
            }
          }

        } else {
          const settings = n ? JSON.parse(n) : {};
          this.settings.title = settings.title;
        }
      }
    },
    'setting.showTitleSpring':{
      handler: ()=> {
        this.debounceGetSprintList();
      }
    },
    updateData(){
      this.debounceGetSprintList();
    },
    'settings.projectId':{
      handler() {
        this.handleProjectChange();
      },
      immediate: true
    },
    projectList(val, old){
      if (val?.length && !old?.length) {
        // eslint-disable-next-line
        if (['BurndownWidget', 'BurnupWidget'].includes(this.widget.type)) {
          this.load(this.settings);
        }
      }
    },
    // eslint-disable-next-line
    currentProjectHasSprintFeature:{
      handler (n){
        if (requestSprintList.includes(this.widget.type) && n){
          this.debounceGetSprintList();
        }
      },
      immediate: false
    }
  },
  computed:{
    sprintRemoved(){
      return !!(this.settings.sprintId || this.settings.sprintIds?.length) && !this.projectSprintList?.some(i => (i.id === this.settings.sprintId || this.settings.sprintIds?.includes(i.id)));
    },
    hasProjectAuth(){
      return this.projectList.find(i => i.id === this.settings.projectId);
    },
    // ...mapGetters('sprint', ['sprintListStore']),
    projectList() {
      return shareData.projectList;
    },
    // eslint-disable-next-line
    currentProjectHasSprintFeature(){
      return this.hasSprintFeatureProjects.some(item=>item.id === this.settings.projectId);
    },
    hasSprintFeatureProjects(){
      return this.projectList.filter(project => !!project.features.module_sprint_switch);
    },
    updateData(){
      return this.settings.projectLabel + this.settings.springName;
    },
    shouldLoadData(){
      // eslint-disable-next-line
      if (['BurndownWidget', 'BurnupWidget'].includes(this.widget.type)) {
        return this.projectList.length;
      }
      return true;
    }
  },
  data() {
    return {
      firstLoading: true,
      loading: false,
      loadingCount: 0,
      settings: { trendType:'Percent' },
      debounceUpdateSettingsData: debounce(this.debounceUpdateSettings, 1000),
      debounceGetSprintList: debounce(this.getSprintList, 500),
      projectSprintList:null,
      noProject:false //无项目或者归档
    };
  },
  async created() {
    this.queueSettings = [];
    // await this.checkPermission();
    // if (requestSprintListSpec.includes(this.widget.type) && this.currentProjectHasSprintFeature){
    //   await this.getSprintList();
    // }
  },
  methods: {
    getAbortOption(){
      return {
        positionId: `${this.widget.i}-${+this.isPreview}`,
        abort: true
      };
    },
    async getSprintList(){
      this.projectSprintList = await this.$store.dispatch('sprint/getProjectSprintList', this.settings.projectId) || [];
    },
    checkPermission(){
      if (!checkPermissionList.includes(this.widget.type)){
        return true;
      }
      if (!this.settings.projectId){
        this.noProject = true;
        return false;
      }
      //处理燃烧图选了版本，不需要处理有没有项目权限 的情况
      // eslint-disable-next-line
      if ((this.widget.type === 'BurndownWidget' || this.widget.type === 'BurnupWidget') && this.settings.burnType === 3){
        this.noPermission = false;
        this.noProject = false;
        return true;
      }
      const currentProject = this.$store.state.app.projectList?.find(item=>item.id === this.settings.projectId);
      //是否无权限
      if (!currentProject){
        this.noPermission = true;
        return false;
      }
      this.noPermission = false;
      this.noProject = false;
      return true;
    },
    async handleProjectChange(){
      // eslint-disable-next-line
      if (requestSprintList.includes(this.widget.type) && this.currentProjectHasSprintFeature){
        await this.debounceGetSprintList();
      }
    },
    resize() {},
    async load(settings) {
      if (!this.shouldLoadData) {
        return;
      }
      this.loadingFinish = 0;
      this.loading = true;
      this.loadingCount++;
      const reload = true;
      try {
        this.loadData && await this.loadData(settings, reload);
      } finally {
        this.loading = false;
        this.loadingCount--;
        setTimeout(() => {
          this.loadingFinish = 1;
        }, 200);
        this.firstLoading = false;
      }
    },
    onlySaveSetting(json) {
      const settings = json ? JSON.parse(json) : {};
      this.settings = { ...this.settings, ...settings };
    },
    async onSettingsChange(json) {
      const settings = json ? JSON.parse(json) : {};
      this.settings = { ...this.settings, ...settings };
      //鉴权不通过无需调用接口
      this.loading = true;
      const result = this.checkPermission();
      if (!result){
        this.isInit = false;
        this.loading = false;
        return;
      }
      return this.load(this.settings);
    },
    updateSettings(data, abortLoadData = false) {
      this.queueSettings.push(data || {});
      this.debounceUpdateSettingsData(data, abortLoadData);
    },
    formatSprintCycle(startDate, endDate) {
      if (!startDate || !endDate) {
        return '-';
      }
      return `${this.$options.filters.formatDate(startDate)} - ${this.$options.filters.formatDate(endDate)}}`;
    },
    debounceUpdateSettings(data, abortLoadData = false) {
      const tmp = [...this.queueSettings];
      this.queueSettings = [];
      // const mergeData = merge({}, ...tmp, data);
      // lodash的merge是进行深层合并，此处处理数组类型的数据时候会有问题
      const mergeData = Object.assign({}, ...tmp, data);
      const newer = { ...this.settings, ...mergeData };
      if (this.json === JSON.stringify(newer) && !abortLoadData) {
        return this.load(this.settings);
      }
      this.$emit('update:settings', newer, abortLoadData);
    },
    //(燃尽图，燃起图)后端传来的预估工时与已用工时为秒，需转换下
    formatListFormSecondToHour(list, keys){
      if (Array.isArray(list) && Array.isArray(keys) && list.length && keys.length) {
        list.forEach(item => {
          keys.forEach(key => {
            if (!item[key]) {
              return;
            }
            const formatVal = item[key] / (60 * 60);
            return item[key] = isInteger(formatVal) ? formatVal : +Number(formatVal).toFixed(1);
          });
        });
      }
      return list;
    },
    //(燃尽图，燃起图)过滤重复时间的数据
    filterRepeatData(list, key, unit = 'month'){
      if (Array.isArray(list) && list.length) {
        const firstData = list.find(item => item.isFirstDate);
        let isPassFirst = false;
        list.forEach((item, index) => {
          if (item.isFirstDate) {
            return;
          }
          if (list.findIndex(i => dayjs(i[key]).isSame(item[key], unit)) !== index &&
            (!dayjs(item[key]).isSame(firstData[key], unit) || isPassFirst)) {
            list.splice(index, 1);
          }
          if (dayjs(item[key]).isSame(firstData[key], unit)) {
            isPassFirst = true;
          }
        });
      }
      return list;
    }
  }
};
